import type { GlucoseFluxGradeInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileValue } from "./TileValue"

export function GlucoseFluxGrade(props: TileProps<GlucoseFluxGradeInsight>) {
  const {
    insightKey,
    range,
  } = props

  const { glucoseCalculations } = useCalculationsContext()
  const { fluxGrade } = glucoseCalculations[range] || {}

  const value = fluxGrade || "--"

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value}
      </TileValue>
    </>
  )
}
